import router from './router';

export default router;
// export { router, store };



// WEBPACK FOOTER //
// ./src/app/library/index.js